module.exports = __webpack_public_path__ + "img/happy-kids-home-03-darkgreen.3963424.svg";